// extracted by mini-css-extract-plugin
module.exports = {"lia-topics-count":"UserTopicsCount_lia-topics-count__wKBWB"};